<div fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row">
    <h3>Dane oświadczenia</h3>
  </div>

  <app-file-drag-and-drop
    [multiple]="false"
    [generateOutput]="true"
    (fileSelected)="fileSelected($event)"
  ></app-file-drag-and-drop>

  <div fxLayout="row">
    <div fxFlex="100">
      <app-datepicker
        label="Data wpisu do rejestru pośredników ubezpieczeniowych"
        placeholder="2000-01-01"
        [required]="false"
        [control]="dateOfEntryInRauControl"
      ></app-datepicker>
    </div>
  </div>

  <div fxLayout="row" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!addStatementFormValid"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
